import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const CorrectionViewDetailsSection = ({ correctionDetails }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!correctionDetails) {
    return null;
  }

  const {
    originalInvoice,
    correctionReason,
    correctionSequence,
    originalInvoiceNumber,
    originalInvoiceDate,
  } = correctionDetails;

  return (
    <div className="w-full pb-6">
      <div className="text-xl font-medium pb-6">
        {t("invoices:correction_title")}
      </div>

      <div className="bg-white rounded-md border p-4 space-y-3">
        <div className="flex flex-wrap gap-4">
          <div className="flex-1 min-w-[200px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:original_invoice")}
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium">{originalInvoiceNumber}</span>
              {originalInvoice && (
                <Button
                  variant="link"
                  className="text-blueText p-0 h-auto"
                  onClick={() => navigate(`/admin/invoices/details/${originalInvoice.id}`)}
                >
                  {t("common:button_view")}
                </Button>
              )}
            </div>
          </div>

          <div className="flex-1 min-w-[200px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:correction_sequence")}
            </div>
            <div className="font-medium">{correctionSequence}</div>
          </div>

          <div className="flex-1 min-w-[200px]">
            <div className="text-sm text-gray-500 mb-1">
              {t("invoices:date_of_creation")}
            </div>
            <div className="font-medium">
              {originalInvoiceDate ? new Date(originalInvoiceDate).toLocaleDateString() : '-'}
            </div>
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-500 mb-1">
            {t("invoices:correction_reason")}
          </div>
          <div className="font-medium">{correctionReason}</div>
        </div>
      </div>
    </div>
  );
};
